const getVariant = (variant) => ({
  mobile: variant === 'mobile',
  desktop: variant === 'desktop'
})

export { getVariant }
